
export const ADD_PRODUCT = "ADD_PRODUCT";
export const DECREMENT_STOCK = "DECREMENT_STOCK";
export const INCREMENT_STOCK = "INCREMENT_STOCK";
